<div class="w-screen max-w-4xl">
  <div class="mb-4 text-xl font-bold">Create New Scenario</div>
  <div class="text-xxs">Select Type:</div>

  <div class="my-5 flex space-x-4 text-xs">
    @for (type of types; track type; let i = $index) {
      <div class="flex flex-1 items-center">
        <input
          name="phases"
          type="radio"
          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
          [id]="type"
          [value]="type"
          [(ngModel)]="selectedTab"
          (change)="activeTabIndex = i"
        />
        <label class="ml-2" [for]="type">
          <span class="block text-sm font-medium text-gray-700">{{ type }}</span>
        </label>
      </div>
    }
  </div>

  @if (activeTabIndex === 0) {
    <div class="text-xs">
      <p class="mb-4 font-medium">Select a milestone and edit the start date and length:</p>
      <div class="grid grid-cols-4 gap-5">
        <div>
          <div class="mb-3">Milestone</div>
          <aux-select [options]="milestoneOptions" />
        </div>
        <div>
          <div class="mb-3">Starting Date</div>
          <aux-input class="tabular-nums" [type]="'date'" />
        </div>
        <div>
          <div class="mb-3"># of Days</div>
          <aux-input class="w-16 tabular-nums" [type]="'number'" />
        </div>
      </div>

      <div class="mt-5 grid grid-cols-2 gap-5">
        @for (table of tables; track table) {
          <div class="rounded border p-4" [ngClass]="{ 'bg-aux-gray-light': table.gray }">
            <div
              class="mb-4 text-sm font-bold leading-5"
              [ngClass]="{
                'text-aux-black': !table.gray,
                'text-aux-blue': table.gray,
              }"
            >
              {{ table.header }}
            </div>
            <div class="grid grid-cols-3 gap-5 text-xs tabular-nums">
              <div class="text-xxs text-aux-gray-lightest">Milestone</div>
              <div class="text-xxs text-aux-gray-lightest">Starting Date</div>
              <div class="text-xxs text-aux-gray-lightest">Length</div>

              @for (data of table.data; track data) {
                <div>{{ data.milestone }}</div>
                <div>{{ data.date }}</div>
                <div>{{ data.length }}</div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (activeTabIndex === 1) {
    <div class="grid w-1/2 grid-cols-2 items-center gap-5 text-xs font-medium">
      <div>Total # of patients</div>
      <aux-input class="w-40 tabular-nums" />

      <div>
        Enrolled patients per site
        <br />
        per month
      </div>
      <aux-input class="w-40" />

      <div>By Site</div>
      <aux-input class="w-40" />

      <div>Select a preset</div>
      <aux-input class="w-40" />
    </div>
  }

  @if (activeTabIndex === 2) {
    <div class="mb-4 text-xs font-medium">Edit Site Addition Drivers</div>
    <div class="grid w-10/12 grid-cols-12 gap-5 text-xs">
      <div class="col-span-2">
        <div class="mb-3 text-xxs"># Sites</div>
        <aux-input class="tabular-nums" [type]="'number'" />
      </div>
      <div class="col-span-5">
        <div class="mb-3 text-xxs">Initiation Time</div>
        <ng-select class="select select__big tabular-nums" />
      </div>
      <div class="col-span-5">
        <div class="mb-3 text-xxs">Enrollment Rate</div>
        <ng-select class="select select__big tabular-nums" />
      </div>

      <div class="col-span-4">
        <div class="mb-3 text-xxs">Per Patient Cost</div>
        <ng-select class="select select__big tabular-nums" />
      </div>
    </div>
  }

  @if (activeTabIndex === 3) {
    <div class="mb-3 grid w-8/12 grid-cols-4 gap-3 text-xs font-medium text-aux-gray-lightest">
      <div>
        Cost
        <br />
        Quadrant
      </div>
      <div>
        Avg. cost
        <br />
        per patient
      </div>
      <div>
        Current
        <br />
        # sites
      </div>
      <div>
        Current
        <br />
        # patients
      </div>
    </div>

    <div class="mb-2 grid w-8/12 grid-cols-4 items-center gap-3 text-xs">
      @for (quadrant of quadrants; track quadrant) {
        <div class="text-xxs">{{ quadrant }}</div>
        <aux-input />
        <aux-input />
        <aux-input />
      }
    </div>
  }

  <div class="mb-5 mt-10 flex items-center space-x-4 text-xs">
    <button type="button" class="btn btn--blue w-24">Create</button>
    <button class="btn--tertiary" type="button">Cancel</button>
  </div>
</div>
